import { getValue } from "@utils/lodash";
import "./notificationbar.scss";
import Dropdown from "../common/Dropdown";
import _ from "lodash";
import { useState } from "react";
export default function NavigationBar(props: any) {
  var commonLicenseIDs =
    getValue(props, `licenseIDs.length`, 0) &&
    getValue(props, `licenseIDs`, []).filter(function (val: string) {
      return getValue(props, `selectedIDs`, []).indexOf(val) != -1;
    });
  //const [showUpdatePopup, setShowUpdatePopup] = useState(false);

  return (
    <section className="navigation-bar-wrapper">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <p className="navigation-bar-wrapper__selected">
            {getValue(props, `selectedIDs.length`, 3)} Selected
          </p>
          {props.isUpdateTaskVisible &&
            getValue(props, `permissions`, []).includes("update") && (
              <>
                <div
                  className="position-relative"
                  onClick={() => {
                    props.showUpdatePopup(true);
                  }}
                >
                  <div className="filter-checklist d-flex align-items-center ms-3">
                    <p className="filter-checklist-text cursor-pointer medium-bold-font">
                      {getValue(props, `selectedIDs.length`, 0) > 1
                        ? "Bulk"
                        : ""}{" "}
                      Update Task
                    </p>
                    <img
                      src="/images/edit-white.svg"
                      className="img-fluid edit-image"
                    />
                  </div>
                </div>
              </>
            )}
          {props.isFilterVisisbile && (
            <>
              <Dropdown />
              <div className="filter-checklist d-flex align-items-center">
                <img src="/images/filter-white.svg" className="img-fluid" />
                <p className="navigation-bar-wrapper__selected cursor-pointer">
                  {/* FILTER SIMILAR CHECKLIST */}
                  Filter Similar Checklist
                </p>
              </div>
            </>
          )}
          {getValue(props, `assignedTaskActive`, false) && (
            <>
              {!getValue(props, `findNotConfiguredIds`, false) && (
                <Dropdown
                  name={"Update Status"}
                  filterOptions={getValue(props, `filterOptions`, [])}
                  handleUpdateStatus={props.handleUpdateStatus}
                />
              )}
              {!getValue(props, `hideConfigure`, false) && (
                <div
                  className="filter-checklist d-flex align-items-center"
                  onClick={props.handleModal}
                >
                  <p className="filter-checklist-text cursor-pointer medium-bold-font">
                    Configure
                  </p>
                  <img
                    src="/images/edit-white.svg"
                    className="img-fluid edit-image"
                  />
                </div>
              )}
            </>
          )}
          {getValue(props, `masterNav`, "") !== "false" &&
            getValue(props, `permissions`, []).includes("update") && (
              <>
                {getValue(props, `products`, []).includes("VA") && (
                  <div
                    className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                    onClick={() => props.handleNavigate("release-to-vendor")}
                  >
                    <h6>
                      {/* RELEASE TO VENDOR */}
                      Release To Vendor
                    </h6>
                    &nbsp;
                    <img src="/images/assignment.svg" className="img-fluid" />
                  </div>
                )}
                {getValue(commonLicenseIDs, `length`, 0) === 0 &&
                  getValue(props, `products`, []).includes("PEC") && (
                    <div
                      className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                      onClick={() => props.handleNavigate("assign-to-PE")}
                    >
                      <h6>
                        {/* ASSIGN TO PE */}
                        Assign To PE
                      </h6>
                      &nbsp;
                      <img src="/images/assignment.svg" className="img-fluid" />
                    </div>
                  )}
                {_.isEqualWith(
                  commonLicenseIDs,
                  getValue(props, `selectedIDs`, [])
                ) &&
                  getValue(props, `products`, []).includes("LICENSE") && (
                    <div
                      className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                      onClick={() => props.handleNavigate("add-to-tracker")}
                    >
                      <h6>
                        {/* ADD TO TRACKER */}
                        Add To Tracker
                      </h6>
                      &nbsp;
                      <img src="/images/assignment.svg" className="img-fluid" />
                    </div>
                  )}
                {getValue(props, `assignTask`, false) &&
                  getValue(props, `products`, []).includes("SELFCOMP") && (
                    <div
                      className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                      onClick={() => props.handleNavigate("assign-task")}
                    >
                      <h6>
                        {/* ASSIGN TASK */}
                        Assign Task
                      </h6>
                      &nbsp;
                      <img src="/images/assignment.svg" className="img-fluid" />
                    </div>
                  )}
              </>
            )}
          {props.multi &&
            getValue(props, `permissions`, []).includes("update") && (
              <>
                <div
                  className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                  onClick={() => props.handleChangeActiveStatus("active")}
                >
                  <img src="/images/assignment.svg" className="img-fluid" />
                  <h6>Mark Active</h6>
                </div>
                <div
                  className="navigation-bar-wrapper__inactive-count d-flex cursor-pointer"
                  onClick={() => props.handleChangeActiveStatus("inactive")}
                >
                  <img src="/images/assignment.svg" className="img-fluid" />
                  <h6>Mark Inactive</h6>
                </div>
              </>
            )}
        </div>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={props.handleRemoveNavItems}
        />
      </div>
    </section>
  );
}
